// src/components/HowItWorksPage.js
import React from 'react';
// We can display the HowItWorks component here, or a dedicated full page version
import HowItWorks from './HowItWorks'; 

const HowItWorksPage = () => {
  return (
    <div className="section-padding">
      <HowItWorks /> 
    </div>
  );
};
export default HowItWorksPage;